import api from './api';
import type {
  TarjetaReceptoraDto,
  TarjetaReceptoraCreateRequest,
} from '@/types/tarjetaReceptora';

export const tarjetasReceptorasApi = {
  findAll: () =>
    api.get<TarjetaReceptoraDto[]>('/tarjetas-receptoras').then((r) => r.data),

  findById: (id: number) =>
    api
      .get<TarjetaReceptoraDto>(`/tarjetas-receptoras/${id}`)
      .then((r) => r.data),

  create: (data: TarjetaReceptoraCreateRequest) =>
    api
      .post<TarjetaReceptoraDto>('/tarjetas-receptoras', data)
      .then((r) => r.data),

  update: (id: number, data: TarjetaReceptoraCreateRequest) =>
    api
      .put<TarjetaReceptoraDto>(`/tarjetas-receptoras/${id}`, data)
      .then((r) => r.data),

  uploadImage: (id: number, formData: FormData) =>
    api
      .post<TarjetaReceptoraDto>(
        `/tarjetas-receptoras/${id}/imagen`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      )
      .then((r) => r.data),

  delete: (id: number) => api.delete(`/tarjetas-receptoras/${id}`),
};
